document.addEventListener('DOMContentLoaded', function () {

  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  var section =
    picker.closest('[id^="shopify-section-"]') ||
    picker.closest('section') ||
    picker.parentElement;

  var form = section.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  form.setAttribute('data-product-form', '');

    /* ---------- Galeria: miniaturas ---------- */
    var mainImage = section.querySelector('[data-product-main-image]');
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        section.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) mainImage.src = thumb.dataset.fullSrc;
      });
    });

    /* ---------- Seletor de variante ---------- */

    var variants = [];
    if (picker) {
      try { variants = JSON.parse(picker.dataset.productJson); } catch (e) { variants = []; }
    }

    var variantIdInput = form.querySelector('[data-product-variant-id]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonText = form.querySelector('[data-add-to-cart-text]');
    var buyNowButton = form.querySelector('[data-buy-now]');
    var buyNowButtonText = form.querySelector('[data-buy-now-text]');
    var priceWrap = section.querySelector('[data-product-price]');
    var stockNote = section.querySelector('[data-stock-note]');
    var badgesWrap = section.querySelector('[data-product-badges]');

    function money(cents) {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function getSelectedOptions() {
      var selected = [];
      if (!picker) return selected;
      picker.querySelectorAll('[data-option-position]').forEach(function (group) {
        if (!group.classList.contains('m-variant-picker__option')) return;
        var active = group.querySelector('.m-variant-picker__value.is-selected');
        selected[parseInt(group.dataset.optionPosition, 10) - 1] = active ? active.dataset.optionValue : null;
      });
      return selected;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function refreshDisabledStates(selected) {
      if (!picker) return;
      picker.querySelectorAll('.m-variant-picker__option').forEach(function (group) {
        var position = parseInt(group.dataset.optionPosition, 10) - 1;
        group.querySelectorAll('.m-variant-picker__value').forEach(function (btn) {
          var candidate = selected.slice();
          candidate[position] = btn.dataset.optionValue;
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) {
              return candidate[i] == null || opt === candidate[i];
            });
          });
          var isAvailable = match ? match.available !== false : true;
          btn.classList.toggle('m-product-card__size--unavailable', !isAvailable);
        });
      });
    }

    function updateUI(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (buyNowButton) buyNowButton.disabled = true;
        if (addButtonText) addButtonText.textContent = 'Indisponível';
        if (buyNowButtonText) buyNowButtonText.textContent = 'Indisponível';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.innerHTML =
            '<span class="m-product-card__price-compare">' + money(variant.compare_at_price) + '</span>' +
            '<span class="m-product-card__price-sale">' + money(variant.price) + '</span>';
        } else {
          priceWrap.innerHTML = '<span class="m-product-card__price-regular">' + money(variant.price) + '</span>';
        }
      }

      if (stockNote) {
        if (!variant.available) {
          stockNote.textContent = 'Esgotado';
        } else if (variant.inventory_management && variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
          stockNote.textContent = 'Apenas ' + variant.inventory_quantity + ' restante' + (variant.inventory_quantity !== 1 ? 's' : '');
        } else {
          stockNote.textContent = 'Em estoque';
        }
      }

      if (badgesWrap) {
        var badge = '';
        if (!variant.available) {
          badge = '<span class="m-badge m-badge--soldout">Esgotado</span>';
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badge = '<span class="m-badge m-badge--sale">-' + pct + '%</span>';
        }
        badgesWrap.innerHTML = badge;
      }

      if (addButton) {
        addButton.disabled = !variant.available;
        if (addButtonText) addButtonText.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';
      }
      if (buyNowButton) {
        buyNowButton.disabled = !variant.available;
        if (buyNowButtonText) buyNowButtonText.textContent = variant.available ? 'Comprar agora' : 'Esgotado';
      }

      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2');
        section.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t.dataset.fullSrc.indexOf(variant.featured_image.id) !== -1 || t.querySelector('img').src === mainImage.src);
        });
      }

      if (picker && picker.dataset.productUrl && window.history) {
        window.history.replaceState({}, '', picker.dataset.productUrl + '?variant=' + variant.id);
      }
    }

    if (picker) {
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('.m-variant-picker__value');
        if (!btn) return;


        var group = btn.closest('.m-variant-picker__option');
        group.querySelectorAll('.m-variant-picker__value').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var labelEl = group.querySelector('[data-option-selected-value]');
        if (labelEl) labelEl.textContent = btn.dataset.optionValue;

        var selected = getSelectedOptions();
        refreshDisabledStates(selected);
        updateUI(findVariant(selected));
      });

      refreshDisabledStates(getSelectedOptions());
    }

    /* ---------- Comprar agora ---------- */
    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        if (buyNowButton.disabled) return;

        buyNowButton.disabled = true;
        if (buyNowButtonText) buyNowButtonText.textContent = 'Processando…';

        var buyNowData = new FormData(form);
        window.MCart.addItem(buyNowData, form).then(function (ok) {
          if (ok) {
            window.location.href = '/checkout';
          } else {
            buyNowButton.disabled = false;
            if (buyNowButtonText) buyNowButtonText.textContent = 'Comprar agora';
          }
        }).catch(function () {
          buyNowButton.disabled = false;
          if (buyNowButtonText) buyNowButtonText.textContent = 'Comprar agora';
        });
      });
    }

    /* ---------- Envio do formulário via AJAX ---------- */
    form.addEventListener('submit', function (e) {
      if (!window.MCart) return;
      e.preventDefault();
      if (addButton) addButton.disabled = true;
      var formData = new FormData(form);
      window.MCart.addItem(formData, form).then(function (ok) {
        if (addButton) addButton.disabled = false;
        if (ok) window.MCart.open();
      });
    });

}); // fim do DOMContentLoaded